import React from 'react'
import { graphql } from 'gatsby'
import style from './pricing.mod.scss'
import { Content, Button, Cta, Block } from '@components'
import { gtmPush } from '@helpers/gtmHelpers'

const Pricing = ({
  cta,
  heading,
  contentNode,
  disclaimer,
  plans,
  subHeading
}) => {
  const modifiers = []
  cta && modifiers.push(style['pricing--cta'])

  return (
    <div className={[style.pricing, ...modifiers].join(' ')}>
      <div className={style.pricing__wrap}>
        <Block gutters>
          <div className={style.pricing__intro}>
            <h2>{heading}</h2>
            <h4>{subHeading}</h4>
            <em>{disclaimer}</em>
          </div>
          {contentNode?.childMarkdownRemark?.html && (
            <div className={style.pricing__features}>
              <Content contentNode={contentNode} />
            </div>
          )}
          <div className={style.pricing__plans}>
            {plans.map(
              ({
                title,
                description,
                price,
                link,
                mostPopular,
                topBoxTextOveride,
                id
              }) => {
                const modifiers = []
                mostPopular && modifiers.push(`${style.pricing__plan}--popular`)
                return (
                  <div
                    className={[style.pricing__plan, ...modifiers].join(' ')}
                    key={`pricing-plan-${id}`}
                  >
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <h3>{price}</h3>
                    <Button
                      to={link?.link?.path || link?.url}
                      onClick={() => {
                        gtmPush({
                          event: `plan-click`,
                          label: `${title} Plan Link`,
                          value: `${link.displayText}`
                        })
                      }}
                    >
                      {link.displayText}
                    </Button>
                    {mostPopular && (
                      <div className={style.pricing__badge}>
                        <span>{topBoxTextOveride || 'Most Popular'}</span>
                      </div>
                    )}
                  </div>
                )
              }
            )}
          </div>
        </Block>
      </div>
      {cta && (
        <div className={style.pricing__cta}>
          <Cta pricing ctaItem={cta} />
        </div>
      )}
    </div>
  )
}

export default Pricing

export const query = graphql`
  fragment Pricing on DatoCmsPricing {
    id
    contentNode {
      childMarkdownRemark {
        html
      }
    }
    disclaimer
    heading
    padding
    background
    plans {
      link {
        ...Link
      }
      description
      mostPopular
      topBoxTextOveride
      price
      title
      id
    }
    subHeading
    cta {
      ...CtaItem
    }
    model {
      apiKey
    }
  }
`
